import { FC, useContext, useEffect, useMemo, useRef } from "react";
import Image from "next/image";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css/pagination";
import "swiper/css";
import { ArrowIcon } from "./arrowIcon";

interface SectionProps {
  isMobile: boolean;
}
type SwiperList = {
  img: string;
  title: string;
  subTitle: string;
  thirdTitle?: string;
};

const swiperList1: SwiperList[] = [
  {
    img: "/banner/home_banner/1.jpg",
    title: "赛讯信息致力于",
    subTitle: "网络与信息安全领域",
    thirdTitle: "专注于安全·网络·5G的服务商提供",
  },
  {
    img: "/banner/home_banner/2.jpg",
    title: "动态零信任安全",
    subTitle: "新一代网络安全架构",
  },
  {
    img: "/banner/home_banner/3.jpg",
    title: "自适应微隔离",
    subTitle: '"自适应、自迁移、自维护"网络隔离策略',
  },
  {
    img: "/banner/home_banner/4.jpg",
    title: "IPv6 下一代 互联网最佳实践",
    subTitle: "架起IPv4·IPv6的桥梁",
  },
  {
    img: "/banner/home_banner/5.jpg",
    title: "自动化运营平台",
    subTitle: "自动化生命周期管理, 构建个性化用户旅程",
  },
  {
    img: "/banner/home_banner/6.jpg",
    title: "应用APP安全防护",
    subTitle: "为APP提供从应用端到服务端的全方位防护",
  },
  {
    img: "/banner/home_banner/7.jpg",
    title: "企业统一安全浏览器",
    subTitle: "多场景需求安全浏览器统一办公入口",
  },
];
const swiperList2 = [
  "/mobile/banner/home_banner/banner1.jpg",
  "/mobile/banner/home_banner/banner2.jpg",
  "/mobile/banner/home_banner/banner3.jpg",
  "/mobile/banner/home_banner/banner4.jpg",
  "/mobile/banner/home_banner/banner5.jpg",
  "/mobile/banner/home_banner/banner6.jpg",
  "/mobile/banner/home_banner/banner7.jpg",
];

export const Section1: FC = () => {
  return (
    <>
      <Swiper
        modules={[Pagination, Autoplay]}
        loop={true}
        autoplay={{
          delay: 2000,
          stopOnLastSlide: false,
          disableOnInteraction: true,
        }}
        pagination={{
          bulletClass:
            "cursor-pointer mr-2 inline-block bg-white opacity-20 h-1 w-7 md:w-14",
          bulletActiveClass: "!opacity-100",
          clickable: true,
        }}
        className="!block md:!hidden"
      >
        {swiperList2.map((item, idx) => (
          <SwiperSlide key={idx} className="bg-transparent flex-center">
            <Image
              src={item}
              alt="banner"
              width="750"
              height="600"
              className="w-full h-full"
            />
          </SwiperSlide>
        ))}
      </Swiper>

      <Swiper
        modules={[Pagination, Autoplay]}
        loop={true}
        autoplay={{
          delay: 2000,
          stopOnLastSlide: false,
          disableOnInteraction: true,
        }}
        pagination={{
          bulletClass:
            "cursor-pointer mr-2 inline-block bg-white opacity-20 h-1 w-7 md:w-14",
          bulletActiveClass: "!opacity-100",
          clickable: true,
        }}
        className="!hidden md:!block"
      >
        {swiperList1.map((item, idx) => (
          <SwiperSlide key={idx} className="bg-transparent flex-center">
            <div className="w-full h-full relative">
              <div className="container absolute left-[50%] top-[54%] translate-x-[-50%] translate-y-[-50%] text-white text-start">
                <h2 className="text-4xl font-bold">{item.title}</h2>
                <h3 className="text-2xl mt-6">{item.subTitle}</h3>
                {item.thirdTitle ? (
                  <h3 className="text-2xl mt-1 mb-12">{item.thirdTitle}</h3>
                ) : (
                  <ArrowIcon
                    className="mt-12"
                    leftClass="w-64 h-1.5 from-[rgba(121,216,128,0)] to-[#43B049]"
                    rightClass="w-8 h-9 text-white"
                  />
                )}
              </div>
              <Image
                src={item.img}
                alt="banner"
                width="2560"
                height="640"
                priority={idx <= 2 ? true : false}
                className="w-full h-[500px] object-cover object-center"
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
};
